import { ContactDetailPage } from "@/features/contact/pages/ContactDetail";
import React from "react";

const ContactDetail = () => {
  return <ContactDetailPage />;
};

export default ContactDetail;
